if(window.localStorage.productTileType === 'undefined' || window.localStorage.productTileType === null) {
    window.localStorage.setItem('productTileType', $('#productListPanel').attr('data-pl-product-list') || 'tiles'); //'tiles', 'img-list', 'list'
}

const bind = function () {
    if (window.localStorage.productTileType !== null) {
        $('#productListPanel').attr('data-pl-product-list', window.localStorage.productTileType);
    }

    $('.sorting').on('click', function (e) {
        e.preventDefault();
        window.localStorage.productTileType = $(this).data('plProductTiles') || 'tiles';
        $('#productListPanel').attr('data-pl-product-list', window.localStorage.productTileType);
    });
}

export {
    bind,
}
